import { render, staticRenderFns } from "./Spbf.vue?vue&type=template&id=4461b4c0&scoped=true"
import script from "./Spbf.vue?vue&type=script&lang=js"
export * from "./Spbf.vue?vue&type=script&lang=js"
import style0 from "./Spbf.vue?vue&type=style&index=0&id=4461b4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461b4c0",
  null
  
)

export default component.exports